import { EVENT_TYPES } from "./constants.js";
import { emit } from "./events.js";
import {
    scopeMatches,
    setCapabilities,
    setConfig,
    setContext,
    setRoute,
} from "./runtime.js";
import { handleBridgeResponse } from "./transport.js";

function normalizeMessage(raw) {
    if (!raw) return null;

    if (typeof raw === "string") {
        try {
            return JSON.parse(raw);
        } catch {
            return null;
        }
    }

    if (typeof raw === "object") return raw;
    return null;
}

function payloadOf(msg) {
    return msg?.payload ?? msg?.data ?? {};
}

function handleShellMessage(event) {
    const msg = normalizeMessage(event?.detail);

    if (handleBridgeResponse(msg)) {
        emit("message", msg);
        return;
    }

    if (!msg || !msg.type) {
        emit("message", msg);
        return;
    }

    const payload = payloadOf(msg);

    switch (msg.type) {
        case EVENT_TYPES.SHELL_CONTEXT: {
            const context = setContext(payload);
            emit(EVENT_TYPES.SHELL_CONTEXT, context);
            emit("message", msg);
            break;
        }

        case EVENT_TYPES.SHELL_CAPABILITIES_CHANGED: {
            const scope = payload.to || payload.target || payload;
            setCapabilities(scope, payload.capabilities || {});
            emit(EVENT_TYPES.SHELL_CAPABILITIES_CHANGED, payload);
            emit("message", msg);
            break;
        }

        case EVENT_TYPES.SHELL_READY: {
            emit(EVENT_TYPES.SHELL_READY, payload);
            emit("message", msg);
            break;
        }

        case EVENT_TYPES.SHELL_CONFIG: {
            setConfig(payload);
            emit(EVENT_TYPES.SHELL_CONFIG, payload);
            emit("message", msg);
            break;
        }

        case EVENT_TYPES.SHELL_ROUTE_CHANGED: {
            const routePayload = payload?.route ? payload : { route: payload, params: {} };
            const route = routePayload.route ?? null;
            const params = routePayload.params ?? {};
            setRoute(route, params);
            emit(EVENT_TYPES.SHELL_ROUTE_CHANGED, { route, params });
            emit("message", msg);
            break;
        }

        case EVENT_TYPES.SHELL_SURFACE_ACTION:
        case EVENT_TYPES.SHELL_SURFACE_CONTROL_CHANGED: {
            emit(msg.type, payload);
            emit("message", msg);
            break;
        }

        default: {
            emit("message", msg);
            break;
        }
    }
}

export function initLifecycle() {
    window.addEventListener("shell:message", handleShellMessage);
}

export function eventMatchesScope(payload, scope) {
    const target = payload?.to || payload?.target || payload;
    return scopeMatches(scope, target);
}
